export const transformString = (s: string) => {
  // Check if the string is not empty
  if (!s) {
    return '';
  }

  // Replace underscores with spaces
  const transformedS = s.replace(/_/g, ' ');

  // Check if the string is empty after replacing
  if (!transformedS) {
    return '';
  }

  // Make the first character uppercase and the rest lowercase
  return (
    transformedS.charAt(0).toUpperCase() + transformedS.slice(1).toLowerCase()
  );
};
